import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IAddImageRequest, IImage } from '../models/requestModels'

export class PostDocApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productImage/doc-add',
      requesterInfo,
    })
  }

  public async addDoc(request: any): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
